import { createRoutine } from 'redux-saga-routines'

export const SET = 'MOVIMIENTOS_LAYOUT/SET'
export const CONTENT = createRoutine('MOVIMIENTOS_LAYOUT/CONTENT')
